/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type cartNode$ref: FragmentReference;
export type cartNode = {|
  +id: string,
  +license_line_items: ?$ReadOnlyArray<?{|
    +id: string,
    +amount: ?number,
    +discount_amount: ?number,
    +track: ?{|
      +id: string,
      +internal_id: ?number,
      +title: ?string,
      +added_to_cart: ?boolean,
      +slug: ?string,
      +assets: ?$ReadOnlyArray<?{|
        +id: string,
        +version: ?string,
        +type: ?string,
        +file_format: ?string,
        +path: ?string,
        +metadata: ?any,
      |}>,
      +artist: ?{|
        +id: string,
        +name: ?string,
        +slug: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
      |},
      +terms: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +is_highlighted: ?boolean,
            +name: ?string,
            +parent_id: ?string,
            +taxonomy: ?{|
              +id: string,
              +internal_id: ?number,
              +name: ?string,
            |},
          |},
        |}>,
      |},
    |},
    +license: ?{|
      +id: string,
      +usages: ?$ReadOnlyArray<?{|
        +id: string,
        +license_id: ?number,
        +air_date: ?any,
        +components: ?$ReadOnlyArray<?{|
          +id: string,
          +component_id: ?number,
          +name: ?string,
          +type: ?string,
        |}>,
      |}>,
    |},
  |}>,
  +total: ?number,
  +$refType: cartNode$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "cartNode",
  "type": "Cart",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "license_line_items",
      "storageKey": null,
      "args": null,
      "concreteType": "LicenseLineItem",
      "plural": true,
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "amount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_amount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "track",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [
            v0,
            v1,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "added_to_cart",
              "args": null,
              "storageKey": null
            },
            v2,
            v4,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "artist",
              "storageKey": null,
              "args": null,
              "concreteType": "Artist",
              "plural": false,
              "selections": [
                v0,
                v5,
                v2,
                v4
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "terms",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTermConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTermEdge",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "TaxonomyTerm",
                      "plural": false,
                      "selections": [
                        v0,
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "is_highlighted",
                          "args": null,
                          "storageKey": null
                        },
                        v5,
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "parent_id",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "taxonomy",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Taxonomy",
                          "plural": false,
                          "selections": [
                            v0,
                            v1,
                            v5
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "license",
          "storageKey": null,
          "args": null,
          "concreteType": "StandardLicense",
          "plural": false,
          "selections": [
            v0,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "usages",
              "storageKey": null,
              "args": null,
              "concreteType": "StandardLicenseUsage",
              "plural": true,
              "selections": [
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "license_id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "air_date",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "components",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "StandardLicenseUsageComponent",
                  "plural": true,
                  "selections": [
                    v0,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "component_id",
                      "args": null,
                      "storageKey": null
                    },
                    v5,
                    v3
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "total",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
(node/*: any*/).hash = 'a70ca21880623ca4e6d961dde5dc1664';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/cartNode.graphql.js